﻿import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";
import { chunkUploadAndFillForDownloadFields } from "./upload";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadDetail") return;

    initTinymce('ForDownloadDescription', 300);
    initShowFileSelectModal();
    initUploadFile();
    initSave();
});

function initShowFileSelectModal() {

    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {

        let fileInfo = $('#FileInfo')[0] as HTMLInputElement;
        let fileInput = document.getElementById("FileInput");

        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }

    });
}

function postForm(url: string, form: HTMLFormElement) {
    tinymce.triggerSave();

    const formData = new FormData(form);

    return $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: function () { $('#spinnerContainer').removeClass('d-none'); },
        complete: function () { $('#spinnerContainer').addClass('d-none'); }
    });
}

function initSave() {
    $("#btnSave").on('click', function () {

        if ($(this).prop("disabled")) {
            return;
        }

        var url = '/ForDownload/Edit';
        const form = $("#formForDownload")[0] as HTMLFormElement;

        let fileInput = $('#fileForDownload')[0] as HTMLInputElement;
        let file = (fileInput && fileInput.files && fileInput.files.length > 0) ? fileInput.files[0] : null;

        // 1) ak nie je nový súbor → SAVE ako doteraz
        if (!file) {
            const request = postForm(url, form);
            request.done(function (res) {
                if (!res.error) window.location.href = res.redirectUrl;
                else {
                    const editorId = $("#forDownloadTinymceId").val() as string;
                    const ed = tinymce.EditorManager.get(editorId);
                    if (ed) ed.remove();

                    $("#forDownloadDetailBody").html(res.html);
                    initTinymce($("#forDownloadTinymceId").val() as string, 300);
                    initShowFileSelectModal();
                }
            });
            request.fail(function (jqXHR) { console.error(jqXHR); });
            return;
        }

        // 2) ak je súbor → najprv chunk upload, potom SAVE (bez pripájania file)
        disableSaveButton();

        chunkUploadAndFillForDownloadFields(file,
            {
                // defaulty sú /admin/uploads/*, takže toto ani nemusíš dávať
                progressBarSelector: "#uploadProgressBar",
                statusSelector: "#uploadStatus"
            },
            {
                onDone: function () {
                    // TERAZ už máš vyplnené #FileUrl, #FileName, #OriginalFileName
                    // a môžeš poslať form normálne cez AJAX (bez file append)
                    const request = postForm(url, form);
                    request.done(function (res) {
                        enableSaveButton();
                        if (!res.error) window.location.href = res.redirectUrl;
                        else {
                            const editorId = $("#forDownloadTinymceId").val() as string;
                            const ed = tinymce.EditorManager.get(editorId);
                            if (ed) ed.remove();

                            $("#forDownloadDetailBody").html(res.html);
                            initTinymce($("#forDownloadTinymceId").val() as string, 300);
                            initShowFileSelectModal();
                        }
                    });
                    request.fail(function (jqXHR) { console.error(jqXHR); });
                },
                onError: function (msg) {
                    enableSaveButton();
                    showMessage("Upload failed: " + msg, "Chyba!");
                }
            }
        );
    });
}

function initUploadFile() {
    $('#uploadFile').on('click', function () {

        let fileInfo = $('#FileInfo')[0] as HTMLInputElement;
        let fileInput = $('#FileInput')[0] as HTMLInputElement;

        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }

    });
}

function disableSaveButton() {
    const $btn = $("#btnSave");
    $btn.prop("disabled", true);
    $btn.addClass("disabled");
    $btn.data("orig-text", $btn.html());
    $btn.html("Uploading...");
}

function enableSaveButton() {
    const $btn = $("#btnSave");
    $btn.prop("disabled", false);
    $btn.removeClass("disabled");

    const origText = $btn.data("orig-text");
    if (origText) {
        $btn.html(origText);
    }
}

